
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.grid-wrapper{
  --gap-count:calc(var(--grid-column--max-count) - 1);
  --total-gap-width:calc(var(--gap-count) * var(--grid-layout-column-gap));
  --grid-item--max-width:calc(
    (100% - var(--total-gap-width)) / var(--grid-column--max-count)
  );

  display:grid;
  grid-template-columns:repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap:var(--grid-layout-column-gap);
  grid-horizontal-gap:var(--grid-layout-horizontal-gap);
  grid-vertical-gap:var(--grid-layout-vertical-gap);
  grid-row-gap:var(--grid-layout-row-gap);
  grid-column-gap:var(--grid-layout-column-gap);
  justify-content:center;
}

@media (min-width: 100vw){
  .full-bleed{
    margin-left:calc(50% - 50vw);
    margin-right:calc(50% - 50vw);
  }
}

.equal-height{
  grid-auto-rows:1fr;
}

.equal-height > *{
    height:100%;
  }

.justify-self > *{
    justify-self:var(--justify-self);
  }

.align-self > *{
    align-self:var(--align-self);
  }

.grid-header{
  display:flex;
  flex-wrap:wrap;
  gap:1rem;
  justify-content:space-between;
  align-items:center;
  margin-bottom:1rem;
}

.grid-cta{
  display:flex;
  gap:3rem;
}
`;